import { CompanyInvoicesController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows the invoice processing ui for companies.
 * @example
 * ```html
 * <salaxy-company-invoices></salaxy-company-invoices>
 * ```
 */
export class CompanyInvoices extends ComponentBase {
    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = {
      /**
       * channel for the invocie processing. Default is PalkkausInvoices.
       */
         channel: "<",
    };

    /** Uses the InvoiceCrudController */
    public controller = CompanyInvoicesController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/invoices/CompanyInvoices.html";

}
